(function() {
    'use strict';

    angular
        .module('receiptApp')
        .controller('CorporationDialogController', CorporationDialogController);

    CorporationDialogController.$inject = ['$scope', '$uibModalInstance', 'lstCustomer', 'idNum', 'NgTableParams'];

    function CorporationDialogController ($scope, $uibModalInstance, lstCustomer, idNum, NgTableParams) {
    	var corporationDlgCtr = this;
    	var receiptScope = $scope.$parent;
    	corporationDlgCtr.idNum = idNum; 
    	corporationDlgCtr.lstCustomer = lstCustomer;
    	corporationDlgCtr.tableParams = new NgTableParams({
    	      page: 1, // show first page
    	      count: 10 // count per page
    	    }, {
    	      filterDelay: 0,
    	      dataset: lstCustomer
    	    });
    	
    	corporationDlgCtr.ok= ok;
    	corporationDlgCtr.cancel= cancel;
    	corporationDlgCtr.selected = {
    	    customer: corporationDlgCtr.lstCustomer[0]
    	  };

    	  function ok() {
    		 receiptScope.isRemoveCorporation = false;  
    	    $uibModalInstance.close(corporationDlgCtr.selected.customer);
    	  };

    	  function cancel() {
    		  if(corporationDlgCtr.lstCustomer.length > 0)
    			  receiptScope.isRemoveCorporation = false;  
    		  else
    			  receiptScope.isRemoveCorporation = true;   
    	    $uibModalInstance.dismiss(receiptScope.isRemoveCorporation);
    	  };
    }
})();
